import { FC } from 'react'

import { useSecondaryMenu } from 'ui/components/BPLayout'
import { AlertsResponse } from '~bank-alerts/types'

export const AlertsSideBar: FC<{ data: AlertsResponse }> = ({ data }) => {
  const showCRB =
    data?.showCRBLicenseDisconnectedCount ||
    data?.showCRBLicenseEntityMismatchCount ||
    data?.showCRBLicenseStatusMismatchCount

  useSecondaryMenu([
    { label: 'Documents Due', hash: 'documents-due' },
    ...(data?.uploads !== undefined ? [{ label: 'Uploads Pending Approval', hash: 'uploads-pending-approval' }] : []),
    ...(data?.applications !== undefined ? [{ label: 'Applications', hash: 'applications' }] : []),
    ...(data?.showCTRs !== undefined ? [{ label: 'CTRs with FinCEN warnings', hash: 'ctr' }] : []),
    ...(data?.showBsaBatches !== undefined ? [{ label: 'BSA Batches to finalize', hash: 'batch' }] : []),
    ...(data?.showSARs !== undefined ? [{ label: 'SARs List', hash: 'sar' }] : []),
    ...(data?.showMonthlyAnalytics !== undefined ? [{ label: 'Monthly Analytics', hash: 'mr' }] : []),
    ...(data?.showQuarterlyAnalytics !== undefined ? [{ label: 'Quarterly Analytics', hash: 'qr' }] : []),
    ...(data?.showHighRiskReview !== undefined ? [{ label: 'High-Risk Review', hash: 'hrr' }] : []),
    ...(data?.annualReviews !== undefined ? [{ label: 'Annual Reviews', hash: 'annual-review' }] : []),
    ...(data?.showAdverseMedia !== undefined ? [{ label: 'Adverse Media', hash: 'adverse-media' }] : []),
    ...(showCRB ? [{ label: 'CRB Monitor', hash: 'crb-monitor' }] : [])
  ])

  return null
}
